import { Radio, styled, Typography } from '@mui/material';
import { theme } from 'src/assets/theme/theme';
import colors from 'src/assets/theme/colors';
import { FieldError } from 'react-hook-form';

interface RadioButtonSelectedProps {
  is_selected: string;
  error?: FieldError;
}

export const StyledRadioButtonCard = styled('span')<RadioButtonSelectedProps>`
  box-sizing: border-box;
  width: 150px;
  height: 150px;
  border: 1px solid
    ${(props) =>
      props.is_selected === 'true' ? colors.blueberry : props.error ? colors.tomatoRed : colors.lightestGrey};
  border-radius: ${theme.spacing(1)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const StyledImgWrapper = styled('span')`
  position: absolute;
  top: ${theme.spacing(6)};
`;

export const StyledInputWrapper = styled('span')`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  bottom: ${theme.spacing(7.25)};
`;

export const StyledLabel = styled('label')`
  cursor: pointer;
  position: relative;
`;

export const StyledText = styled(Typography)<RadioButtonSelectedProps>`
  text-transform: none;
  font-weight: 600;
  font-size: 18px;
  position: absolute;
  width: 150px;
  height: 30px;
  bottom: -28px;
  text-align: center;
  color: ${(props) => (props.is_selected === 'true' ? colors.blueberry : colors.liquorice)};
  text-transform: capitalize;
`;

export const StyledInput = styled(Radio)`
  margin: 0;
  width: ${theme.spacing(5)};
  height: ${theme.spacing(5)};
  appearance: none;
  border: ${theme.spacing(0.5)} solid ${colors.black};
  border-radius: 50%;
  background-clip: content-box;
  padding: 3px;

  &.Mui-checked {
    color: ${colors.blueberry};
  }
`;

export const HiddenInput = styled(Radio)`
  margin: 0;
  width: 1px;
  height: 1px;
  border: ${theme.spacing(0.5)} solid ${colors.black};
  padding: 0px;
  position: absolute;
  bottom: -30px;
  right: -30px;
  visibility: hidden;

  &.Mui-checked {
    color: ${colors.blueberry};
  }
`;

export const StyledInfoTooltipLogoWrapper = styled('span')`
  position: absolute;
  top: ${theme.spacing(4)};
  right: ${theme.spacing(4)};
`;
